export const verifyPhone = (payload: { phone: string }) => ({
    type: '@saga/VERIFY_PHONE',
    payload,
});
